export const mockGameState: any = {
  RoomCode: "",
  Game: "PollBattle",
  Votes: [],
  Participants: [],
  AudienceList: [],
  QuestionsAndAnswers: [],
  VotingClosed: false,
  VotingStarted: false,
  VotingStartTime: "2024-11-01T10:00:20.021Z",
  VotingEndTime: "2024-11-01T10:01:20.021Z",
  TimedDuration: "0s",
  DurationRemaining: "0s",
  Error: null,
};
